import { List } from 'antd'
import { ListProps } from 'antd/lib/list'
import { useIndex, UseIndexOptions } from 'app/lib/hooks/useQuery'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import { CollectionArgs } from 'app/redux/actions/typing'

interface Props<T> extends ListProps<T> {
  recordType: RecordTypeEnum
  hideIfEmpty?: boolean
  params?: CollectionArgs
  displayHeader?: boolean
  visualRecordType?: string
  queryOptions?: Partial<UseIndexOptions<T>>
  pageSize?: number
}

function KList<T extends { id: number }>({
  recordType,
  dataSource = [],
  params,
  hideIfEmpty,
  displayHeader,
  visualRecordType,
  pageSize = 10,
  queryOptions,
  ...others
}: Props<T>) {
  const hasData = Boolean(dataSource.length)

  const { data: response, loading } = useIndex<T>(recordType, {
    pageSize,
    variables: params,
    skip: hasData,
    ...queryOptions
  })

  const data = hasData ? dataSource : response?.nodes || []

  const { tComponent } = useTranslation({
    recordType: visualRecordType || recordType,
    componentType: 'data_display',
    scope: 'list'
  })

  const empty = (): boolean => data.length === 0 && dataSource.length === 0

  const getHeader = () => {
    if (displayHeader) {
      return (
        <h5 className="list-header">
          {tComponent({
            id: 'title'
          })}
        </h5>
      )
    }
  }

  return (
    <List<T>
      className={hideIfEmpty && empty() && 'd-none'}
      rowKey="id"
      size="default"
      loading={loading}
      dataSource={data}
      header={getHeader()}
      {...others}
    />
  )
}

export default KList
